import { render, staticRenderFns } from "./ChatMsg.vue?vue&type=template&id=00a50494&scoped=true&"
import script from "./ChatMsg.vue?vue&type=script&lang=js&"
export * from "./ChatMsg.vue?vue&type=script&lang=js&"
import style0 from "./ChatMsg.vue?vue&type=style&index=0&id=00a50494&scoped=true&lang=css&"
import style1 from "./ChatMsg.vue?vue&type=style&index=1&id=00a50494&scoped=true&lang=css&"
import style2 from "./ChatMsg.vue?vue&type=style&index=2&id=00a50494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a50494",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBottomNavigation,VBtn,VCard,VCol,VRow,VTextarea})
